export default __webpack_public_path__ + "static/media/aurora-login-icon.60c0762a.png";